module.exports = __webpack_public_path__ + "static/media/DSC07421.14364dfc.jpg";